module.exports = __webpack_public_path__ + "img/ebdeac6cb5c5e658f02a51d475177ee4.png";